/**
 * Sticky sidebar scroll with windows.
 * @param $
 */
export function stickySideBar($ : JQueryStatic = jQuery) {
    var stickySidebar = $('.sticky');

    if (stickySidebar.length > 0) {
        var stickyHeight = stickySidebar.height(),
            sidebarTop = stickySidebar.offset().top - 20;
    }
    console.log('sidebarTop',sidebarTop);

// on scroll move the sidebar
    $(window).scroll(function () {
        if (stickySidebar.length > 0) {
            var scrollTop = $(window).scrollTop();
            console.log('scrollTop top',scrollTop);
            if (sidebarTop < scrollTop) {
                stickySidebar.css('top', scrollTop - sidebarTop);

                // stop the sticky sidebar at the footer to avoid overlapping
                var sidebarBottom = stickySidebar.offset().top + stickyHeight,
                    stickyStop = $('.main-content').offset().top + $('.main-content').height();
                if (stickyStop < sidebarBottom) {
                    var stopPosition = $('.main-content').height() - stickyHeight;
                    stickySidebar.css('top', stopPosition);
                }
            }
            else {
                stickySidebar.css('top', '0');
            }
        }
    });

    $(window).resize(function () {
        if (stickySidebar.length > 0) {
            stickyHeight = stickySidebar.height();
        }
        if($(window).width() < 900) {
            stickySidebar = $(' ');
        }
    });
}

stickySideBar();


// WEBPACK FOOTER //
// ./assets/ts/src/helpers/sticky-sidebar.ts